module.exports = "<div _v-ccb4807e=\"\"> <h1 class=question _v-ccb4807e=\"\">{{ question.title }}（多选）</h1> <li class=option :class=\"{'checked':selectedItems.indexOf(item)>-1}\" v-for=\"item in question.options\" @click=select(item) _v-ccb4807e=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':selectedItems.length==0}\" @click=goNext _v-ccb4807e=\"\">下一题</div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-ccb4807e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/q9.vue
 ** module id = 72
 ** module chunks = 1
 **/